// extracted by mini-css-extract-plugin
module.exports = {"cartoes":"Cartao_cartoes__3ixvW","mobile":"Cartao_mobile__3rOhX","cartao":"Cartao_cartao__2gKYo","ativo":"Cartao_ativo__20Hr2"};